import React from 'react';
import Moviesa from './Moviesa';
import Moviesb from './Moviesb';

const favvSeries = "Moviesa";

// const FavS = () => {
//     if(favSeries === "Moviesb"){
//         return <Moviesa />
//     } else {
//         return <Moviesb />
//     }
// }


const Apppp = () =>(
   <>
       {favvSeries === "Moviesa" ? <Moviesa /> : <Moviesb />}
   </>
)
export default Apppp;